// @ts-nocheck
import { EventBus, makeID } from '@/utils/rfEpc'

// 事件总线
// 1. onKeyMsg 扣扳机事件
// 2. onReadTagResult 读取到标签
// 3. onScanBarcodeResult 扫描条码结果
const eventBus = new EventBus(1)

const promiseCallbacks = {}

const showError = error => {
  alert('[Internal error]\n' + error)
}

const parseJSON = str => {
  try {
    return JSON.parse(str)
  } catch (error) {
    showError(error)
    return null
  }
}

const callNative = (method, ...restParams) => {
  return new Promise((resolve, reject) => {
    if (!window.leadWebToAndroidBridgeAPI) {
      const error = 'Native API not found'
      showError(error)
      reject(error)
    }
    if (!window.leadWebToAndroidBridgeAPI[method]) {
      const error = `Native method ${method} not found`
      showError(error)
      reject(error)
    }
    const id = makeID()
    try {
      window.leadWebToAndroidBridgeAPI[method](id, ...restParams)
    } catch (error) {
      showError(method + ':' + error)
      reject(error)
      return
    }
    promiseCallbacks[id] = {
      resolve,
      reject
    }
  })
}

/**
 * 设置扣扳机事件
 * @param key
 * 0 = 无状态
 * 1 = Rfid读取模式
 * 2 = 扫描条码模式
 * @param mIsDataFlag 是否在停止读取时返回当次读取数据（默认false = 不返回）
 */
export const setKeyCall = (key, mIsDataFlag = false) => {
  return callNative('setKeyCall', key, mIsDataFlag)
}
/**
 * 开始读取(盘点模式)
 * @param onReadTagResult 读取到标签的回调
 */
export const startRFID = (mIsDataFlag = false) => {
  return callNative('startRFID', mIsDataFlag)
}
/**
 * 开始读取(单标签找货模式)
 * @param epc 需要找货的EPC值（可选）
 */
export const startFindRFID = epc => {
  return callNative('startFindRFID', epc)
}
/**
 * 停止读取
 */
export const stopRFID = () => {
  return callNative('stopRFID')
}
/**
 * 开始扫描条码
 */
export const startScan = () => {
  return callNative('startScan')
}
/**
 * 设置RFID参数
 */
// export const setReadSetting = (settings: ReadSettings) => {
//   return callNative('setReadSetting', JSON.stringify(settings));
// };
export const setReadSetting = power => {
  return callNative('setReadSetting', power)
}
/**
 * 获取ReadSetting参数
 */
export const getReadSetting = () => {
  return callNative('getReadSetting')
}

export const getAppData = () => {
  console.log('getAppData')
  return callNative('getAppData')
}

export const onAppData = callback => {
  eventBus.on('onAppData', callback)
}

export const onReadSetting = callback => {
  eventBus.on('onReadSetting', callback)
}

export const onKeyMsg = callback => {
  eventBus.on('onKeyMsg', callback)
}

export const onReadTagResult = callback => {
  eventBus.on('onReadTagResult', callback)
}

export const onReadListTagResult = callback => {
  eventBus.on('onReadListTagResult', callback)
}

export const onScanBarcodeResult = callback => {
  eventBus.on('onScanBarcodeResult', callback)
}

/**
 * 扫描条码结果回调
 */
window.onScanBarcodeResult = arg => {
  // alert('onScanBarcodeResult' + arg);
  // const params = parseJSON<string>(arg);
  const params = arg
  eventBus.emit('onScanBarcodeResult', params)
  // alert('onScanBarcodeResult' + params);
  // return 'abc123';
}

/**
 * 读取标签数据回调
 */
window.onReadTagResult = arg => {
  const data = parseJSON(arg)
  eventBus.emit('onReadTagResult', data)
}

/**
 * 读取标签数据回调（当前阶段）
 */
window.onReadListTagResult = arg => {
  const data = parseJSON(arg)
  eventBus.emit('onReadListTagResult', data)
}

/**
 * 操作结果回调
 */
window.onLeadWebToAndroidBridgeMsg = arg => {
  const params = parseJSON(arg)
  const { id, isSuccess, msg } = params

  const { resolve, reject } = promiseCallbacks[id]
  if (isSuccess) {
    resolve(msg)
  } else {
    reject(msg)
  }
  delete promiseCallbacks[id]
}

window.onKeyMsg = arg => {
  const params = parseJSON(arg)
  eventBus.emit('onKeyMsg', params)
}

window.onReadSetting = arg => {
  const params = parseJSON(arg)
  eventBus.emit('onReadSetting', params)
}

window.onAppData = arg => {
  const params = parseJSON(arg)
  eventBus.emit('onAppData', params)
}
